import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const assetV2Api = createApi({
  reducerPath: 'assetV2Api',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1' }),
  tagTypes: ['AssetV2', 'AssetCategory', 'AssetType'],
  endpoints: (builder) => ({
    getAssetCategories: builder.query({
      query: () => '/asset_categories',
      providesTags: ['AssetCategory']
    }),
    getAssetTypes: builder.query({
      query: (categoryId) => categoryId ? `/asset_types?asset_category_id=${categoryId}` : '/asset_types',
      providesTags: ['AssetType']
    }),
    getAssetsV2: builder.query({
      query: (params = '') => params ? `/assets?${params}` : '/assets',
      providesTags: ['AssetV2']
    }),
    getAssetV2: builder.query({
      query: (id) => `/assets/${id}`,
      providesTags: ['AssetV2']
    }),
    createAssetV2: builder.mutation({
      query: (body) => ({
        url: '/assets',
        method: 'POST',
        body
      }),
      invalidatesTags: ['AssetV2']
    }),
    updateAssetV2: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/assets/${id}`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['AssetV2']
    })
  })
})

export const {
  useGetAssetCategoriesQuery,
  useGetAssetTypesQuery,
  useGetAssetsV2Query,
  useGetAssetV2Query,
  useCreateAssetV2Mutation,
  useUpdateAssetV2Mutation
} = assetV2Api
